import { BasicCartesianChartConfig } from '@app/data/interface/widget-config';
import {
  BasicCartesianChartEchartConfigTemplate,
  BasicCartesianChartAxisTemplate,
  BasicCartesianChartColourPalette,
} from '@app/data/widget-config-templates/basic-cartesian-chart';
export const WhanganuiRiverFlow: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    grid: {
      ...BasicCartesianChartEchartConfigTemplate.grid,
      right: '7%',
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'm³/s',
        axisLine: {
          show: true,
          lineStyle: {
            color: BasicCartesianChartColourPalette[1],
          },
        },
        axisLabel: {
          color: BasicCartesianChartColourPalette[1],
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Stream Flow',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'Stream Flow: Whanganui at Pipiriki',
    widgetId: 3,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'hrc_whanganui_at_pipiriki',
        analyteIdentifier: 'River flow',
        valueField: 'avg',
        label: 'Stream Flow',
      },
    ],
  },
};

export const UaPutikiWharanui: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093', '#f26b4b', '#00b1d8', '#26312b'],
    grid: {
      top: '25%',
      left: '8%',
      right: '8%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'm³/s',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Relative Water Level\nm',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#f26b4b',
          },
        },
        axisLabel: {
          color: '#f26b4b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Rainfall\nmm',
        position: 'right',
        offset: 80,
        inverse: true,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#00b1d8',
          },
        },
        axisLabel: {
          color: '#00b1d8',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Water Temp\n°C',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#26312b',
          },
        },
        axisLabel: {
          color: '#26312b',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Water Flow',
        areaStyle: {},
        itemStyle: {
          opacity: 0.3,
        },
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Relative Water Level',
        areaStyle: {},
        itemStyle: {
          opacity: 0.3,
        },
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Rainfall',
        areaStyle: {},
        itemStyle: {
          opacity: 0.3,
        },
        emphasis: {
          focus: 'series',
        },
        lineStyle: {
          width: 1,
        },
        markArea: {
          silent: true,
          itemStyle: {
            opacity: 0.3,
          },
        },
      },
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Water Temperature',
        areaStyle: {},
        itemStyle: {
          opacity: 0.3,
        },
      },
    ],
  },
  dataConfig: {
    title: 'UA - Rainfall and Relative Water Level: Pūtiki Wharanui - Whanganui at Te Rewa',
    widgetId: 2,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'hrc_whanganui_at_te_rewa',
        analyteIdentifier: 'River flow',
        valueField: 'avg',
        label: 'Water Flow',
      },
      {
        environmentalDataSourceIdentifier: 'hrc_whanganui_at_te_rewa',
        analyteIdentifier: 'relative-water-level',
        valueField: 'avg',
        label: 'Relative Water Level',
      },
      {
        environmentalDataSourceIdentifier: 'hrc_whanganui_at_te_rewa',
        analyteIdentifier: 'precipitation',
        valueField: 'sum',
        label: 'Rainfall',
      },
      {
        environmentalDataSourceIdentifier: 'hrc_whanganui_at_te_rewa',
        analyteIdentifier: 'water-temperature',
        valueField: 'avg',
        label: 'Water Temperature',
      },
    ],
  },
};

export const OhotuFlow: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    grid: {
      ...BasicCartesianChartEchartConfigTemplate.grid,
      right: '7%',
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'm³/s',
        axisLine: {
          show: true,
          lineStyle: {
            color: BasicCartesianChartColourPalette[1],
          },
        },
        axisLabel: {
          color: BasicCartesianChartColourPalette[1],
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Stream Flow',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'Stream Flow: Ōhotu (ATH-2008011821)',
    widgetId: 3,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'hrc_ath_2008011821',
        analyteIdentifier: 'River flow',
        valueField: 'avg',
        label: 'Stream Flow',
      },
    ],
  },
};
